<script>

var init = function (zendeskHost) {    
    if (!typeof(window.zEmbed) == undefined || !window.zEmbed) {                
        // eslint-disable-next-line
        window.zEmbed||function(e,t){var n,o,d,i,s,a=[],r=document.createElement("iframe");window.zEmbed=function(){a.push(arguments)},window.zE=window.zE||window.zEmbed,r.src="javascript:false",r.title="",r.role="presentation",(r.frameElement||r).style.cssText="display: none",d=document.getElementsByTagName("script"),d=d[d.length-1],d.parentNode.insertBefore(r,d),i=r.contentWindow,s=i.document;try{o=s}catch(e){n=document.domain,r.src='javascript:var d=document.open();d.domain="'+n+'";void(0);',o=s}o.open()._l=function(){var e=this.createElement("script");n&&(this.domain=n),e.id="js-iframe-async",e.src="https://assets.zendesk.com/embeddable_framework/main.js",this.t=+new Date,this.zendeskHost=zendeskHost,this.zEQueue=a,this.body.appendChild(e)},o.write('<body onload="document._l();">'),o.close()}();
    }
}

var hideButton = function () {
    if (!window.zE) {
        if (process.env.NODE_ENV !== 'production') {
            console.warn('[vue-zendesk]Must call \'zendesk.init()\' first before \'toggleButton\'.')
        }
        return
    }
    var zE = window.zE;
    !!zE &&  zE(function() {
        // eslint-disable-next-line
        $zopim(function() {
            // eslint-disable-next-line
            $zopim.livechat.button.hide();
        });
    });
}

var toggleChatWindow = function () {
    if (!window.zE) {
        if (process.env.NODE_ENV !== 'production') {
            console.warn('[vue-zendesk]Must call \'zendesk.init()\' first before \'toggleChatWindow\'.')
        }
        return
    }
    var zE = window.zE;
    !!zE && zE(function () {
        // eslint-disable-next-line
        $zopim(function() {            
            // eslint-disable-next-line            
            var $zop = $zopim;                  
            if(!$zop.livechat.window.getDisplay()) {
                $zop.livechat.window.onHide(hideButton);
                $zop.livechat.window.show();    
            } else {
                $zop.livechat.window.hide(); 
            }            
        });        
    })
}

export {
    init,    
    hideButton,
    toggleChatWindow    
}

export default {
    init,    
    hideButton,
    toggleChatWindow
}
</script>


